export default __webpack_public_path__ + "static/media/print.30518a58.svg";